import React from "react";
import PropTypes from "prop-types";

import Carousel from "./nounproject-carousel";

class IconAPICustomBlock extends React.Component {
    static defaultProps = {
        slides: [
            {
                title: "Adobe Spark Video",
                description:
                    " Uses Noun Project Icon API to let users add icons to their slideshows, presentations, ads, and stories.",
                permalink: "https://spark.adobe.com/?ref=nounproject",
                background: `url(${require("../../img/homepage/api_adobe_bg@2x.png")}) 0% 0% / cover`,
                image: require("../../img/homepage/api_adobe@2x.png")
            },
            {
                title: "Teespring",
                description:
                    " Uses Noun Project Icon API to let their users add icons to their t-shirts and other products.",
                permalink: "https://teespring.com/?ref=nounproject",
                background: "#FFFFFF",
                image: require("../../img/homepage/api_teespring@2x.png")
            },
            {
                title: "Tailor Brands",
                description:
                    " Uses Noun Project Icon API to help their users pair iconography in their branding.",
                permalink: "https://www.tailorbrands.com/?ref=nounproject",
                background: "#E4394F",
                image: require("../../img/homepage/api_tailorbrands@2x.png")
            },
            {
                title: "Slidebean",
                description:
                    " Uses Noun Project Icon API to automatically create beautiful presentations.",
                permalink: "https://slidebean.com/?ref=nounproject",
                background: "#FFFFFF",
                image: require("../../img/homepage/api_slidebean@2x.png")
            }
        ]
    };
    static propTypes = {
        slides: PropTypes.array.isRequired
    };

    render() {
        let carouselItems = this.renderCarouselItems();

        // to make a banner: remove className `container row` and add class banner
        return (
            <div className="custom-block icon-api margin-t-xxl">
                <style>
                    {`
                .icon-api{
                  color: #000000;
                  text-align: left;
                }
                .api-list-item{
                    width: 100%;
                    height: 200px;
                    align-items: center;
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                    opacity: 0;
                    animation-name: pop-in;
                    animation-duration: 0.5s;
                    animation-fill-mode: forwards;
                }
                .icon-api .text-container{
                    background: rgba(0,0,0,.75);
                    color: #FFFFFF;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: center;
                    padding: 24px;
                }
                .icon-api .text-container .text-link{
                    color: #FFFFFF;
                }
                .api-carousel .carousel-item{
                    max-width: 100%;
                    width: 100%;
                }
                .api-carousel .carousel-item .img-container{

                }
                .api-carousel .carousel-item {
                    margin-left: 0;
                    list-style: none;
                }
                .api-carousel .collection-list_arrow:not(.disabled):hover{
                    color: #000000;
                }

                @media(max-width: 959px) {
                    .api-carousel-container{
                        display: none;
                    }
                }

            `}
                </style>
                <div className="container row margin-xl padding-t-xl padding-b-xl">
                    <div className="col-lg-6 col-md-6 col-xs-6">
                        <h3 className="font-xxlarge weight-medium">
                            Integrate with
                            <br /> our Icon API
                        </h3>
                        <p className="font-medium weight-light margin-r-l">
                            Use the Noun Project Icon API to tell visual
                            stories, create real-time infographics, build
                            interactive games, or whatever crazy idea you have.
                            <br />
                            <br />
                            What do you want to build?
                        </p>
                        <a href="/developers/" className="button small green">
                            Learn more
                        </a>
                    </div>
                    <div
                        className="api-carousel-container col-lg-6 col-md-6 col-xs-6"
                        style={{
                            background: "#f2f2f2",
                            position: "relative",
                            paddingBottom: "8px",
                            display: "flex",
                            alignItems: "center"
                        }}
                    >
                        <div className="api-carousel">
                            <Carousel
                                items={carouselItems}
                                itemsPerView={1}
                                maxWidth={470}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderCarouselItems() {
        let carouselItems = [];

        this.props.slides.forEach(slide => {
            carouselItems.push(
                <li
                    key={`api-slide.${this.props.slides.indexOf(slide)}`}
                    className="carousel-item"
                >
                    <div
                        className="api-list-item display-flex"
                        style={{
                            background: `${slide.background}`,
                            backgroundSize: "cover"
                        }}
                    >
                        <div className="api-img-container">
                            <img src={slide.image} width="150" height="150" />
                        </div>
                        <div className="text-container padding-l">
                            <h3 className="api-list-item-name font-medium">
                                {slide.title}
                            </h3>
                            <p>{slide.description}</p>
                            <a
                                className="text-link"
                                href={slide.permalink}
                                target="_blank"
                            >
                                Learn more
                            </a>
                        </div>
                    </div>
                </li>
            );
        });

        return carouselItems;
    }
}

export default IconAPICustomBlock;
